import { render, staticRenderFns } from "./VabBoxAreaLeftPanel.vue?vue&type=template&id=496efcae"
import script from "./VabBoxAreaLeftPanel.vue?vue&type=script&lang=js"
export * from "./VabBoxAreaLeftPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496efcae')) {
      api.createRecord('496efcae', component.options)
    } else {
      api.reload('496efcae', component.options)
    }
    module.hot.accept("./VabBoxAreaLeftPanel.vue?vue&type=template&id=496efcae", function () {
      api.rerender('496efcae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabBoxArea/components/VabBoxAreaLeftPanel.vue"
export default component.exports